import { AimsCommonPopupEditorData, AimsCommonTableHeader, AimsCommonTableHeaderType } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { QtHistory } from '../trainingCommon';

@Component({
  selector: 'app-completed-training-dialog',
  templateUrl: './completed-training-dialog.component.html',
  styleUrls: ['./completed-training-dialog.component.css']
})
export class CompletedTrainingDialogComponent implements OnInit {

  public formGroup: any;
  newQtHistory: QtHistory;
  qualTaskValues = this.transferHttp.getHot(`Tr/GetQualTasksForDropDown`);
  today = new Date();
  isSelfTrained: boolean;
  allQualTaskValues = [];
  filteredQttValues: any[];
  employeeValues: any;

  trainerLookupColumns:AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Trainer', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active?', type:AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  constructor( contentData: AimsCommonPopupEditorData,
    private transferHttp: TransferHttpService,
  ) {

    this.formGroup = contentData.formGroup;
    this.newQtHistory = contentData.contentData.newQtHistory;
    this.isSelfTrained = contentData.contentData.isSelfTrained;
    this.filteredQttValues = contentData.contentData.filteredQttValues;
    this.employeeValues = contentData.contentData.employeeValues;

    this.formGroup.addControl('completedOn', new FormControl(null, Validators.required));
    if (!this.isSelfTrained) {
      this.formGroup.addControl('trainedById', new FormControl(null, ));
    }
  }

  public getQualTaskDescription(qualTaskId: number): string {
    var x = this.allQualTaskValues.filter(qt => qt.qualTaskId == qualTaskId).map(qt => qt.qtDesc)[0];
    return x;
  }

  ngOnInit(): void {
    this.qualTaskValues.subscribe(data => {
      this.allQualTaskValues = data;
       });
  }

}
